<template>
  <el-container>
    <el-header class="animate__animated animate__fadeInDown">
      <h3 class="nesc_title40">{{ $t('lang.corporateCulture') }}</h3>
    </el-header>
    <!-- 企业文化 -->
    <el-main>
      <div :class="{animated: show}" class="nesc_about_content clearfix">
        <div class="nesc_j2s1_list clearfix" :style="{background:`url(${bgImg }) center / cover no-repeat`}">
          <div v-for="(item, index) in corporateCultures" :key="index" class="nesc_j2s1_li">
            <div class="nesc_j2s1_lisbox clearfix">
              <h4 class="nesc_n1a1s1_title">{{ $t('lang.' + item.title) }}</h4>
              <div class="nesc_n1a1s1_txt">
                <p v-html="$t('lang.' + item.content)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import bgImg from '../../assets/image/home.jpeg'
export default {
  name: 'About',
  data: () => {
    return {
      bgImg: bgImg,
      show: !1,
      corporateCultures: [{ title: 'vision', content: 'visionContent' }, { title: 'mission', content: 'missionContent' }, { title: 'coreValue', content: 'coreValueContent' }]
    }
  },

  mounted() {
    setTimeout(() => {
      this.show = !0
    }, 100)
  },

  destroyed() {
    this.show = !1
  }
}
</script>

<style scoped lang="scss">
.el-header {
  height: auto !important;
}
.el-main {
  margin-bottom: 100px;
}
.nesc_about_content {
  position: relative;
  z-index: 1;
  overflow: hidden;
  margin: 0 auto;
}

.nesc_j2s1_list {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 560px;
}

.nesc_j2s1_list::before {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  z-index: 20;
  width: 100%;
  height: 100%;
  background: #f7f7f7;
  transition: all 1.2s ease-in;
}

.nesc_about_content.animated .nesc_j2s1_list::before {
  width: 0;
}

.nesc_j2s1_list::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .8);
}

/* 单个li项 */
.nesc_j2s1_li {
  position: relative;
  z-index: 10;
  float: left;
  width: 33.333333%;
  height: 100%;
  text-align: center;
  padding: 200px 0 100px;
  overflow: auto;
}

.nesc_j2s1_li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
}

.nesc_j2s1_li:not(:last-child) {
  border-right: 1px solid #666;
}

/* lisbox */
.nesc_j2s1_lisbox {
  display: inline-block;
  vertical-align: top;
  text-align: left;
  width: 465px;
  max-width: calc(100% - 60px);
}

/* title-文本 */
.nesc_n1a1s1_title {
  font-size: 40px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 60px;
}

/* txt-文本 */
.nesc_n1a1s1_txt p {
  font-size: 24px;
  line-height: 1.75;
  color: #d0d0d0;
}

@media screen and (max-width: 1680px) {
  .nesc_j2s1_list {
    height: calc(100vh - 100px);
    min-height: 440px;
    max-height: 580px;
  }
  .nesc_j2s1_li {
    padding-top: 5.7%;
  }
  .nesc_j2s1_lisbox {
    font-size: 80px;
  }
  .nesc_n1a1s1_title {
    font-size: 38px;
  }
  .nesc_n1a1s1_txt p {
    font-size: 22px;
  }
}

@media screen and (max-width: 1440px) {
  .nesc_j2s1_lisbox {
    font-size: 70px;
  }
  .nesc_n1a1s1_title {
    margin-bottom: 40px;
  }
  .nesc_n1a1s1_txt p {
    font-size: 20px;
    line-height: 1.5;
  }
}

@media screen and (max-width: 991px) {
  .nesc_j2s1_list {
    width: 768px;
    height: calc(100vh - 100px);
    min-height: 440px;
    max-height: 490px;
    background-size: 1152px 432.6px !important;
  }
  .nesc_j2s1_list {
    width: 100%;
  }
  .nesc_j2s1_list {
    min-height: auto;
    height: 415.5px;
    background-size: cover !important;
  }
  .nesc_j2s1_lisbox {
    max-width: calc(100% - 40px);
  }
  .nesc_n1a1s1_title {
    font-size: 32px;
    margin-bottom: 20px;
  }
  .nesc_n1a1s1_txt p {
    font-size: 18px;
  }
}

@media screen and (max-width: 767px) {
  .nesc_j2s1_list {
    min-height: auto;
    height: 415.5px;
  }
  .nesc_j2s1_li {
    padding: 30px 0;
    width: 100%;
    height: auto;
    border-right: 0 !important;
    border-bottom: 1px solid #666;
  }
  .nesc_j2s1_lisbox {
    font-size: 60px;
  }
  .nesc_n1a1s1_title {
    font-size: 24px;
  }
  .nesc_n1a1s1_txt p {
    font-size: 16px;
  }
}
</style>
